import { z } from 'zod';
import { ErrorCode } from '../error-codes';
import { DataSourceKindSchema } from './data-source-kind.schema';
import { DataSyncDifferenceSchema } from './data-sync-difference.schema';
/**
 * A finished apply always ends `done`, even when outcomes failed; `failed`
 * means only a failed read or a stale lock (failureCode
 * DATA_SYNC_RUN_STALE), so `failed` ⇔ `failureCode !== null`.
 * Apply runs from `review`; a retry runs from `done` with `failed` outcomes
 * and re-writes exactly those.
 */ export const DataSyncRunStatusSchema = z.enum([
    'reading',
    'review',
    'applying',
    'done',
    'failed'
]);
/** A run the admin still has open: reading, in review, or applying. */ export const DataSyncOpenRunStatusSchema = DataSyncRunStatusSchema.extract([
    'reading',
    'review',
    'applying'
]);
/** A run that ended: applied (`done`) or stopped by a failed read or a stale lock. */ export const DataSyncFinishedRunStatusSchema = DataSyncRunStatusSchema.extract([
    'done',
    'failed'
]);
/**
 * `conflict`: can never apply as reviewed (Bliks changed since, a dependency
 * did not apply, or a guard refused it); a new Abgleich proposes it again.
 * `failed`: a transient error, which a retry writes again.
 */ export const DataSyncDifferenceOutcomeSchema = z.enum([
    'applied',
    'failed',
    'conflict'
]);
/** Why a source person is never created nor a leaver. */ export const DataSyncSkippedReasonSchema = z.enum([
    'missingEmail'
]);
/** The run as the API returns it; what only its apply reads stays on the server. */ export const DataSyncRunSchema = z.object({
    id: z.string(),
    status: DataSyncRunStatusSchema,
    sourceKind: DataSourceKindSchema,
    startedAt: z.string(),
    /** User id of the admin who started the run. */ startedBy: z.string(),
    differences: z.array(DataSyncDifferenceSchema),
    /** Source people without email: never created, never a leaver. */ skippedPeople: z.array(z.object({
        firstName: z.string(),
        lastName: z.string(),
        reason: DataSyncSkippedReasonSchema
    })),
    /** Keyed by difference id; a difference without an entry was not applied yet. */ outcomes: z.record(z.string(), DataSyncDifferenceOutcomeSchema),
    appliedAt: z.string().nullable(),
    failureCode: z.enum(ErrorCode).nullable(),
    /**
   * false for an Excel upload without the downloaded-ids list (a hand-built
   * file, or a download from before the list): it proposes no Abgang and no
   * Entfernen.
   */ hasDownloadList: z.boolean()
});

//# sourceMappingURL=data-sync-run.schema.js.map